(function () {
  function getCollectionUrl(baseUrl, sortType) {
    const sortTypes = {
      alphabetical: "title-ascending",
      alphabetical_reversed: "title-descending",
      products_low: "price-ascending",
      products_high: "price-descending",
      date: "created-ascending",
      date_reversed: "created-descending",
      featured: "manual",
      best_selling: "best-selling",
    };

    const sortBy = sortTypes[sortType] || sortTypes.alphabetical;
    return `${baseUrl}?sort_by=${sortBy}`;
  }

  function filterSoldOutProducts(items, hideSoldOut) {
    if (!hideSoldOut) return items;
    
    return items.filter(item => {
      const soldOutBadge = item.querySelector('.badge--sold-out');
      const soldOutPrice = item.querySelector('.price--sold-out');
      return !soldOutBadge && !soldOutPrice;
    });
  }

  async function handleResponse(response, section, limitProducts, hideSoldOut) {
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    const targetGrid = section.querySelector("#products-grid");
    const sourceGrid = doc?.getElementById("product-grid");
    if (!targetGrid || !sourceGrid || !sourceGrid?.children) return;

    let sourceItems = Array.from(sourceGrid.children);
    
    // Filtra i prodotti esauriti se necessario
    if (hideSoldOut) {
      sourceItems = filterSoldOutProducts(sourceItems, hideSoldOut);
    }
    
    if (sourceItems.length > limitProducts) {
      const firstItems = sourceItems.slice(0, limitProducts);
      targetGrid.innerHTML = "";
      firstItems.forEach((item) => {
        targetGrid.appendChild(item);
      });
    } else {
      targetGrid.innerHTML = "";
      sourceItems.forEach((item) => {
        targetGrid.appendChild(item);
      });
    }
  }

  const initSection = async (section) => {
    if (!section || !section.classList.contains("products-grid-section"))
      return;

    const box = section.querySelector(".products-grid");
    if (!box) return;

    const isDynamicLoad = box.dataset.isDynamicLoad === "true";
    const baseUrl = box.dataset.baseUrl;
    const sortType = box.dataset.sortType;
    const limitProducts = Number(box.dataset.limitProducts);
    const hideSoldOut = box.dataset.hideSoldOut === "true";

    // Se hide_sold_out è attivo e non è dynamic loading, filtra i prodotti già presenti
    if (hideSoldOut && !isDynamicLoad) {
      const targetGrid = box.querySelector("#products-grid");
      if (targetGrid) {
        let allItems = Array.from(targetGrid.children);
        const availableItems = filterSoldOutProducts(allItems, hideSoldOut);
        const itemsToShow = availableItems.slice(0, limitProducts);
        
        targetGrid.innerHTML = "";
        itemsToShow.forEach((item) => {
          targetGrid.appendChild(item);
        });
      }
    }

    if (isDynamicLoad && baseUrl && baseUrl !== "none" && sortType) {
      const url = getCollectionUrl(baseUrl, sortType);

      box.classList.add("products-grid--loading");
      try {
        const response = await fetch(url);
        await handleResponse(response, box, limitProducts, hideSoldOut);
        try {
          colorSwatches();
        } catch (err) {}
        // Here can make initSlider
      } catch (error) {
        console.error(
          "Products grid: Error when fetching the collection page:",
          error
        );
      } finally {
        box.classList.remove("products-grid--loading");
      }
    } else {
      box.classList.remove("products-grid--loading");
      // Here can make initSlider
    }
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();